<template>
  <li class="dropdown user user-menu">
    <a href="javascript:;" class="dropdown-toggle" data-toggle="dropdown">
      <!-- The user image in the navbar-->
      <img :src="user.avatar" class="user-image" alt="User Image">
      <!-- hidden-xs hides the username on small devices so only the image appears. -->
      <span class="hidden-xs">{{user.displayName}}</span>
    </a>
    <!-- Account Info and Menu -->
    <ul class="dropdown-menu">
      <li class="user-header" style="height:auto;min-height:85px;padding-bottom:15px;">
        <img :src="user.avatar" class="img-circle" alt="User Image">
        <p>
          <span>{{user.displayName}}</span>
          <small v-for="role in user.roles" :key="role">{{role}}</small>
        </p>
      </li>
      <li class="user-footer">
        <a @click="onLogout()" class="btn btn-default btn-flat btn-block">
          <i class="icon ion-sign-out"></i>
          <span>Logout</span>
        </a>
      </li>
      <li class="user-footer">
        <a @click="onChangePassword()" class="btn btn-default btn-flat btn-block">
          <i class="icon ion-key"></i>
          <span>Change Password</span>
        </a>
      </li>
    </ul>
  </li>
</template>

<script>
export default {
  name: 'UserMenu',
  props: ['user'],
  methods: {
    onLogout() {
      this.$store.commit('SET_USER', '')
      this.$store.commit('SET_TOKEN', '')
      this.$store.commit('SET_TOKEN_VALID_AT', '')

      if (window.localStorage) {
        window.localStorage.setItem('user', '')
        window.localStorage.setItem('token', '')
        window.localStorage.setItem('tokenValidAt', '')
      }

      this.$router.push('/login')
    },
    logout() {

    },
    onChangePassword() {
      this.$router.push('/admin/changepassword')
    }
  }
}
</script>



// WEBPACK FOOTER //
// UserMenu.vue?7940fad3